var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoContentBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.5889 0.6996 59 59",
    width: 59,
    height: 59,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.252,
    height: 21.862,
    transform: "translate(0 0)",
    fill: "#b9bdc3"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -108.41109466552734, 21.699594497680657)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 59,
    transform: "translate(109 -21)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    transform: "translate(120 -10)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(130.536 -2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.477,19H3a1,1,0,0,1,0-2H9.333A5.674,5.674,0,0,1,16,12V1.093A1.093,1.093,0,0,0,14.907,0H2.093A2.093,2.093,0,0,0,0,2.093V18a3,3,0,0,0,3,3h7.425a5.679,5.679,0,0,1-.948-2M5,4h6a1,1,0,0,1,0,2H5A1,1,0,0,1,5,4",
    fill: "#b9bdc3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,13.359a4.251,4.251,0,1,0,4.252,4.252A4.257,4.257,0,0,0,15,13.359m1.771,5.56-.462.462L15,18.073l-1.308,1.308-.462-.462,1.308-1.308L13.23,16.3l.462-.463L15,17.148l1.309-1.308.462.463-1.308,1.308Z",
    fill: "#b9bdc3"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoContentBook);
export default __webpack_public_path__ + "static/media/no-content-book.447275967e8cc096441583c0cee66a5b.svg";
export { ForwardRef as ReactComponent };